import { render, staticRenderFns } from "./qc-configure-status3.vue?vue&type=template&id=55142c90&scoped=true"
import script from "./qc-configure-status3.vue?vue&type=script&lang=js"
export * from "./qc-configure-status3.vue?vue&type=script&lang=js"
import style0 from "./qc-configure-status3.vue?vue&type=style&index=0&id=55142c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55142c90",
  null
  
)

export default component.exports